export const slug = "kiosk";
export const title = "Kiosk";
export const section = "Core";
export const content = `
# Kiosk

The Kiosk is a simplified full-screen display designed for a tablet in your waiting room. It lets clients check themselves in and see their place in the queue.

## What the Kiosk Shows

- A **welcome screen** with instructions for checking in.
- After check-in, the client's **queue position** and an estimated wait time.
- A live list of **clients currently being served**, so people know when it is almost their turn.

## How Clients Use the Kiosk

1. The client taps **Check In** on the welcome screen.
2. They search for their name or scan a QR code linked to their record.
3. They confirm their household size and any item preferences.
4. Their name is added to the Saturday queue.

## Toggling a Client's Kiosk Visibility

By default, a client's name appears on the queue display when they are being served. To hide a specific client's name from the public screen (for privacy):

1. Open the client's detail page.
2. Toggle **Show on Kiosk** to off.

That client's slot will show as "Next Client" on the kiosk instead of their name.

## QR Code Download

Each client has a personal QR code that pre-fills their check-in. To download it:

1. Open the client's detail page.
2. Click **Download QR Code**.
3. Print and give it to the client — they can scan it at the kiosk for instant check-in.

## Setting Up the Kiosk Device

Navigate to \`/kiosk\` on the tablet and enable **Full Screen** (F11 or your browser's full-screen option). The page auto-refreshes and requires no login.
`;
